<template>
  <input
    :name="name"
    type="hidden"
    :value="storeData.value"
  >
</template>

<script>
import storeKey from '@dui/mixins/store-key';

export default {
  mixins: [
    storeKey,
  ],
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    storeData() {
      return this.loadFromStore();
    },
  },
};
</script>
